__turbopack_context__.v({
  "active": "NKHSKW_active",
  "hidden": "NKHSKW_hidden",
  "icon": "NKHSKW_icon",
  "is-active": "NKHSKW_is-active",
  "name": "NKHSKW_name",
  "producer-marker": "NKHSKW_producer-marker",
  "producer-marker-card": "NKHSKW_producer-marker-card",
});
